import { useEffect, useState } from 'react'
import { base } from 'utils/constants'

const useAirtableGetFiltered = (id) => {
  const [data, setData] = useState([])

  useEffect(() => {
    base('Products')
      .select({
        view: 'Grid view',
        filterByFormula: `Find("${id}", {category_name}& '')`,
      })
      .eachPage((records, fetchNextPage) => {
        setData(records)
        fetchNextPage()
      })
  }, [id])

  return { data }
}

export default useAirtableGetFiltered
